module.exports = __webpack_public_path__ + "static/media/UELogo.ce68bf37.jpg";